<div class="ph-circle"></div>
<div class="ph-bars">
    <div class="ph-bar"></div>
    <div class="ph-bar"></div>
</div>
